export default (editorDocument, org) => {
  const orgType = org.getAttribute('type');
  let orgNodeOrdinal;
  if (orgType === 'skill_organization') {
    const { parentElement: orgParent } = org;
    orgNodeOrdinal = [...orgParent.children].indexOf(org) + 1;
  } else {
    const dataKeyAttribute = org.getAttribute('data-key');
    const orgNode = editorDocument.getNode(dataKeyAttribute);
    const { data: orgNodeData } = orgNode;
    orgNodeOrdinal = orgNodeData.get('Ordinal');
  }
  return orgNodeOrdinal;
};
